<template>
  <div>
    <ServiceDashboard />
    <!-- <div
      class="
        counterup-area
        pt--10
        pb--50
        bg-theme-gradient-2
        theme-text-white
        inner-counter-two
      "
    >
      <v-container>
        <Counter />
      </v-container>
    </div> -->
    <Contact />
  </div>
</template>
<script>
import ServiceDashboard from "../components/ServiceDashboard";
import Counter from "../components/Counter";
import Contact from "../views/Contact";
export default {
  components: {
    ServiceDashboard,
    Counter,
    Contact,
  },
};
</script>
